import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { AuthContext } from "../../Header/auth - context";
import { useSelector } from 'react-redux';
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import CustomDropdown from '../../custom/customDropdown';
import { translateCol } from '../../custom/columnI18n';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import 'primeicons/primeicons.css';

const Dozvole = () => {
  const { t } = useTranslation();

    const toast = useRef(null);
    const auth = useContext(AuthContext);
    const trip = useSelector(state => state.trip)
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
        const formRef = useRef(null);
            const [selectedRowIdPermit, setSelectedRowIdPermit] = useState(null);
            const isSelected = (row) => String(getIdPermit(row)) === String(selectedRowIdPermit);
            const [PermitsDB, setPermitsDB] = useState(null)
            const [izabran, setIzabran] = useState(false)
            const [poruka, setPoruka] = useState('Izaberite putni nalog kako bi povukli dozvole.')
            const [idPermit, setIdPermit] = useState(null)
            const [popuni, setPopuni] = useState(false)
            const [globalFilter, setGlobalFilter] = useState(null);
            const [first, setFirst] = useState(0);
            const [tableData, setTableData] = useState(null);
            const [allColumns, setAllColumns] = useState([]);
            const [selectedColumns, setSelectedColumns] = useState([]);
            const [originalColumnOrder, setOriginalColumnOrder] = useState([]);
    
        const [formSubmitted, setFormSubmitted] = useState(false);
    
            const getIdPermit = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
            ///DATA
    
            const [formDataPermit, setFormDataPermit] = useState({
              id_permit: null,
              napomena: null,
              /* Prazno znaci "tura jos traje, ne zna se" — nije isto sto i
                 "vracena neiskoriscena". Zato nema podrazumevane vrednosti. */
              Ishod: null
            });
            const [ishodDB, setIshodDB] = useState([]);

const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };
        
      useEffect(()=>{
          if(!formSubmitted) {
                    let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  putniNalog: trip
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/permits/MGSITrip", requestOptions)
                              .then(handleErrors)
                              .then((data) => {

                                    if(data && data.message){
                                        toast.current.show({
                                        severity: "warn",
                                        summary: "Upozorenje!",
                                        detail: data.message,
                                        life: 3000,
                                        });
                                        setPoruka(data.message)
                                        return
                                    }  
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
  
                                setPermitsDB(parsedData.PermitsDB)
                                setIshodDB(parsedData.IshodDB || [])
                                setTableData(parsedData.PermitsOnTripDB)
                                
                             if (parsedData.PermitsOnTripDB && parsedData.PermitsOnTripDB.length > 0) {
                                                const columns = Object.keys(parsedData.PermitsOnTripDB[0])
                                                    /* IshodId je sifra za formu; u tabeli se prikazuje
                                                       naziv iz kolone "Ishod", ne go broj. */
                                                    .filter(key => !['ID', 'IshodId'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(parsedData.PermitsOnTripDB[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
          } 
      },[trip,formSubmitted])

const resetData = ()=> {
    setFormDataPermit({
        id_permit: null,
        napomena: '',
        Ishod: null
    })
}

const handleDeleteFunc = () => {
       
            confirmDialog({
            message: "Želite skinuti dozvolu sa ture?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async (id) => {
      
 setFormSubmitted(true)
  let idValue;
  if(idPermit == null && !isNaN(Number(id)))
    idValue = id
  else
    idValue = idPermit
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idValue
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/deletePermit", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno brisanje dozvole!",
                life: 3000,
                });
                resetData()
                setIdPermit(null)
                setFormSubmitted(false)
                setSelectedRowIdPermit(null)
                //fillDataTableMovement()
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali dozvolu za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 
  const popuniStavke = (apiData) => {
   
    setFormDataPermit({
        id_permit: apiData[0].id_permit || null,
        napomena: apiData[0].napomena || '',
        /* `?? null`, ne `|| null` — sifra ne moze biti 0, ali navika sa `||`
           je ono sto tiho pretvara validnu nulu u prazno. */
        Ishod: apiData[0].IshodId ?? null
      });
};
      const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali dozvolu da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/getPermitSingle", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                         
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka dozvole!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {

              //DATA
                  const hasAnyValuePermit = Object.values(formDataPermit).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataPermit
                        };

                  if(izabran && idPermit){
                 if(hasAnyValuePermit){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idPermit),
                                id_putni_nalog: trip,
                                formDataPermit: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/updatePermit", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                
                               if(data){

                                if(data[0].message){
                                toast.current.show({
                                severity: "warn",
                                summary: data[0].message,
                                life: 3000,
                                });
                                
                               } else {
                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka dozvole na turi!",
                                life: 3000,
                                });
                               
                               }
                                setFormSubmitted(false)
                                setIdPermit(null)
                                setSelectedRowIdPermit(null)
                                resetData()
                                } 
                                
                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke kretanja!",
                        life: 3000,
                    });
                }
           
           
            } else {
                  if(hasAnyValuePermit){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_putni_nalog: trip,
                                  formDataPermit: payload
                              }),
                          };
                         
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/insertPermit", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                    
                                 if(data && data[0].message){
                                     toast.current.show({
                                            severity: "warn",
                                            summary: "Upozorenje!",
                                            detail: data[0].message,
                                            life: 3000,
                                        });
                                    return
                                 }
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka dozvole!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke dozvole za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataPermit) {
        setFormDataPermit(prev => ({ ...prev, [name]: value }));
        }
    };
  

  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Dozvole');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      /* Prevodi se SAMO prikaz. `headers` ostaju sirovi aliasi, jer se po njima
         cita `row[headers[i]]` — prevedeno ime ne postoji kao kljuc u podacima. */
      const headerRow = worksheet.addRow(headers.map(h => translateCol(t, h)));
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Dozvole - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                  <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                  {selectedRowIdPermit && <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFunc} data-pr-tooltip="Obriši" />}
              </div>
              <input
                  type="search"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  placeholder={t('nova.phPretraga')}
                  className="p-inputtext p-component"
                  style={{ width: '30%' }}
              />
          </div>
      );

  const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const choosePermit = (rowData) => {
      const id = getIdPermit(rowData);

    setSelectedRowIdPermit((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if(next) {
      setIzabran(true)
      setIdPermit(next)
      popuniRedove(id) 
      }
      else {
      setIzabran(false)
      setIdPermit(null)
      resetData()
      }

    return next;
  });
 
  
}

     const previewBodyTemplatePermit = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => choosePermit(rowData)}
              />
            
        </div>
      );
    };

    return(
        <div className="dozvole_ture">
            <Toast ref={toast} />
                    { trip ? null : <p class="infoPoruka" style={{margin:'2% 2% 2% 4%', width:'100%'}}>{poruka}</p> }
                     <div className='col-12'>
                                    <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                                               <div className='blagajnaDashboard' style={{display:'flex', gap:'1rem', alignItems:'flex-start', flexWrap:'wrap'}}>
                                                  <div style={{flex:'1 1 35%', minWidth:'280px'}}>
                                                  <Card>
                                                 <div className="gridLicni kretanja" style={{gap:'5%'}}>
                                                     <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                                         <label htmlFor="id_permit">{t('ture.dozvola')}:</label>
                                                             <CustomDropdown 
                                                                 id="id_permit" 
                                                                 name="id_permit" 
                                                                 required
                                                                 invalid={invalidControl(formDataPermit.id_permit)}
                                                                 value={formDataPermit.id_permit} 
                                                                 options={PermitsDB || []} 
                                                                 optionLabel="label"
                                                                 onChange={handleChange}
                                                                 placeholder={t('ture.phDozvolu')}
                                                                 />
                                                     </div>
                                                   <div className="col-12 md:col-6 kretanja_inputi" style={{display:'flex', flexDirection:'column'}}>
                                                     <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                                     <InputText
                                                         id="napomena"
                                                         name="napomena" value={formDataPermit.napomena} onChange={handleChange}
                                                         style={{width:'100%'}}
                                                         />
                                                 </div>
                                                   {/* Ishod NIJE obavezan: pri zaduzenju se jos ne zna sta ce
                                                       biti sa dozvolom. Popunjava se naknadno, izborom reda u
                                                       tabeli. Prazno zato znaci "tura jos traje". */}
                                                   <div className="col-12 md:col-6 kretanja_inputi" style={{display:'flex', flexDirection:'column'}}>
                                                     <label htmlFor="Ishod">{t('ture.ishodDozvole')}:</label>
                                                         <CustomDropdown
                                                             id="Ishod"
                                                             name="Ishod"
                                                             value={formDataPermit.Ishod}
                                                             options={ishodDB || []}
                                                             optionLabel="label"
                                                             onChange={handleChange}
                                                             placeholder={t('ture.phIshodDozvole')}
                                                             />
                                                 </div>
                                             </div>
                                         </Card>
                                                  <div className="formUnosZap buttonUnosZap">
                                                    <button type="submit" onClick={handleFormSubmit} className="btn btn-success" style={{whiteSpace:'nowrap', minWidth:'100px'}}>
                                                      {idPermit ? "SAČUVAJ" : "UNOS"}
                                                    </button>
                                                  </div>
                                                  </div>
                                                  <div style={{flex:'2 1 55%', minWidth:'300px'}}>
                                               <Card>
                                                    <Tooltip target=".export-buttons>button" position="bottom" />
                                                        <DataTable
                                                               value={tableData || []}
                                                               paginator
                                                               rows={10}
                                                               first={first}
                                                               globalFilter={globalFilter}
                                                               onPage={(e) => setFirst(e.first)}
                                                               scrollable
                                                               header={header}
                                                               scrollHeight="30vh"
                                                               emptyMessage={t('common.noDataTable')}
                                                               resizableColumns
                                                               className="turePregledTable stavke-tabela"
                                                               columnResizeMode="expand"
                                                               rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                                             >
                                                               {selectedColumns.map((colKey) => {
                                                               const colMeta = allColumns.find(col => col.value === colKey);
                                                               return (
                                                                 <Column
                                                                   key={colKey}
                                                                   field={colKey}
                                                                   header={translateCol(t, colMeta?.label || colKey)}
                                                                   sortable
                                                                   body={(rowData) => {
                                                                     if (isButtonColumn(colKey)) {
                                                                       return previewBodyTemplatePermit(rowData, colKey);
                                                                     }
                                                                     return rowData[colKey] || '-';
                                                                   }}
                                                                   style={{ minWidth: '150px'}}
                                                                 />
                                                               );
                                                             })}
                                                         </DataTable>
                                               </Card>
                                                  </div>
                                               </div>
                                       </form>
                                 </div>
        </div>
        
    )
}
export default Dozvole;